import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Dialog } from "@mui/material";

import useStyles from "./BulletBalancePopupStyles";

import closeImg from "../../assets/imgs/bulletFactory/close.png";

interface BulletBalancePopupProps {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const BulletBalancePopup: React.FC<BulletBalancePopupProps> = ({
  openModal,
  setOpenModal,
}) => {
  const { classes } = useStyles();

  const handleClose = () => {
    setOpenModal(false);
  };

  return (
    <Dialog open={openModal} onClose={handleClose} className={classes.body}>
      <Box className={classes.modalContent}>
        <Box className={classes.closeIconBody}>
          <Button onClick={handleClose}>
            <CloseIcon htmlColor="gray" />
          </Button>
        </Box>

        <Box className={classes.contentBody}>
          <Box component={"img"} src={closeImg} className={classes.logoImg} />
          <Box className={classes.titleText}>Not enough bullets!</Box>

          <Box className={classes.details}>
            You are too slow mobster, or you are trying to buy more bullets than
            available. Try again later
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default BulletBalancePopup;
